export default function WebAppOperationNotAllowed() {
  // eslint-disable-next-line no-alert
  alert(`Não é possível realizar essa ação através de nosso aplicativo`);
}
